import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { DocsLayout } from './DocsLayout';
import { TableOfContents } from './TableOfContents/TableOfContents';
import { DOCS_TABS } from '../constants';
import {
  ArticleContentWrapper,
  BackButton,
  ContentGrid,
  DocsContent,
  ParagraphText,
  TableOfContentsWrapper,
} from '../styles';
import { MarkdownDoc } from './MarkdownDoc';
import { useMarkdownDoc } from '../hooks/useMarkdownDoc';

interface DocsArticleProps {
  docsBasePath: string;
  tabId: string;
}

export function DocsArticle({ docsBasePath, tabId }: DocsArticleProps) {
  const navigate = useNavigate();
  const { slug, sectionId } = useParams<{ slug: string; sectionId?: string }>();

  let docPath: string | null = null;

  if (slug) {
    if (sectionId) {
      docPath = `${docsBasePath}/${sectionId}/${slug}.md`;
    } else {
      docPath = `${docsBasePath}/${slug}.md`;
    }
  }

  const { markdown, isLoading, hasError } = useMarkdownDoc(docPath);

  const currentTabIndex = DOCS_TABS.findIndex(tab => tab.id === tabId);
  const currentTab = currentTabIndex >= 0 ? currentTabIndex : 0;

  function handleTabChange(_event: React.ChangeEvent<{}>, newValue: number) {
    const nextTab = DOCS_TABS[newValue];

    if (nextTab) {
      navigate(`/docs-v2/${nextTab.id}`);
    }
  }

  return (
    <DocsLayout
      tabs={DOCS_TABS}
      currentTab={currentTab}
      onTabChange={handleTabChange}
      isSubPage
    >
      <ContentGrid>
        <DocsContent>
          <ArticleContentWrapper>
            <BackButton
              startIcon={<ArrowBackIcon />}
              color="primary"
              onClick={() => navigate(-1)}
            >
              Back
            </BackButton>
            {isLoading ? (
              <ParagraphText>Loading article...</ParagraphText>
            ) : null}
            {hasError ? (
              <ParagraphText>
                Unable to load this article. Please try again later.
              </ParagraphText>
            ) : null}
            {markdown ? <MarkdownDoc markdown={markdown} /> : null}
          </ArticleContentWrapper>
        </DocsContent>
        <TableOfContentsWrapper>
          <TableOfContents selectedTabId={tabId} />
        </TableOfContentsWrapper>
      </ContentGrid>
    </DocsLayout>
  );
}
